@if (showParentTitle) {
  <app-title-pages-component [pageData]="pageData"></app-title-pages-component>
}

<router-outlet></router-outlet>
